const state = {
  data: [],
  item: {},
  isPending: false,
};

export default state;
